import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ApprofondimentiComponent } from './approfondimenti.component';
import { ApprofondimentiPostComponent } from './approfondimenti-post/approfondimenti-post.component';

const routes: Routes = [
  { path: ':approfondimentiId', component: ApprofondimentiPostComponent },
  { path: '', component: ApprofondimentiComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApprofondimentiRoutingModule { }
